var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgVControlFullscreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.11 17.778h2.223v-4.445h4.444v-2.222h-6.666v6.667zM22.222 11.111v2.222h4.444v4.445h2.222V11.11h-6.666zM26.666 26.667h-4.444v2.222h6.666v-6.667h-2.222v4.445zM13.333 22.222h-2.222v6.667h6.666v-2.222h-4.444v-4.445z",
    fill: "#fff"
  })));
}

export default SvgVControlFullscreen;